export default "__VITE_ASSET__DO9O2JB0__"